export default __webpack_public_path__ + "static/media/longchamp16.42a213b1.jpg";